import React from 'react';
import { observer } from 'mobx-react';
import { DragAndDrop } from '@ann/web-components';
import { EmptyWorkspaceStateContainer } from './EmptyWorkspaceState.styled';

const EmptyWorkspaceState = observer(({ 
  vaultUuid,
  openFileSelector,
  handleDrop
}) => {
  return (
    <EmptyWorkspaceStateContainer>
      {/* Hidden input is rendered in parent component (DriveWorkspace) */}
      <DragAndDrop
        title="This drive is empty"
        description="Start by uploading your documents. You can also connect them to agents to automate your workflow. Drag and drop here, or click upload documents"
        manualUploadButton={true}
        onUploadClick={openFileSelector}
        onDrop={handleDrop}
        acceptedFileTypes={[".pdf", ".doc", ".docx", ".jpg", ".png", ".xlsx"]}
      />
    </EmptyWorkspaceStateContainer>
  );
});

export default EmptyWorkspaceState;

